import { Emblem3D } from "../site/Emblem3D";
import { FadeUp, MaskLines } from "../site/Reveal";

const SPECS = [
  ["Placement", "Lower-right front panel"],
  ["Finish", "Polished silver-tone metal"],
  ["Mark", "Stylized markhor head with spiral horns"],
  ["Diameter", "[to confirm]"],
];

export const EmblemSection = () => (
  <section id="emblem" className="relative overflow-hidden bg-night py-24 text-ivory md:py-36" data-testid="emblem-section">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(45%_50%_at_30%_50%,rgba(216,220,224,0.16),transparent_70%)]" />
    <div className="relative mx-auto grid max-w-[1600px] items-center gap-16 px-5 md:px-10 lg:grid-cols-2">
      <FadeUp className="mx-auto w-[min(78vw,480px)]">
        <Emblem3D testid="emblem-section-3d" />
        <p className="mt-10 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1A6]">Move your cursor to tilt the emblem</p>
      </FadeUp>
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#A1A1A6]">The emblem</p>
        <MaskLines inView lines={["A signature", <em key="s">in silver.</em>]} className="mt-4 font-display text-5xl font-light leading-[0.92] md:text-7xl" />
        <FadeUp className="mt-6 max-w-md text-base leading-relaxed text-[#C9C9CC]">
          The markhor — the wild mountain goat famed for its spiral horns — lives where few others can. Our small metal coin carries that spirit on every bag: quiet, precise and instantly recognizable.
        </FadeUp>
        <FadeUp delay={0.1} className="mt-10 grid grid-cols-[1fr_auto] items-end gap-6">
          <dl className="divide-y divide-white/10 border-y border-white/10">
            {SPECS.map(([k, v]) => (
              <div key={k} className="flex justify-between gap-6 py-4 text-sm">
                <dt className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#A1A1A6]">{k}</dt>
                <dd className="text-right text-ivory">{v}</dd>
              </div>
            ))}
          </dl>
          <div className="hidden h-40 w-32 overflow-hidden rounded-t-full sm:block">
            <img src="/img/v-emblem.webp" alt="Close-up of the MARKHOR emblem on the bag" className="h-full w-full object-cover" />
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
